// export const BASE_URL = "https://rohitrinkuserver.vercel.app/api/";
export const BASE_URL = "https://api.rohitrinku.com/api/";

// export const BASE_URL = "https://rohitrinkuserver.vercel.app/api/";


